var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-transition',{attrs:{"name":"slide-down","appear":""}},[(!!_vm.text)?_c('div',{staticClass:"msg-bar e-link text-center white--text",class:_vm.classes,style:(`top: ${_vm.margin ? _vm.margin : 0}px`),on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }